import React, { useEffect, useState } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";

import "./style/style.scss";
import "./style/animation.scss";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";
import getContentById from "../../../../shared/utils/getContentById";
import ImageOrVideo from "../../../../shared/components/ImageOrVideo/Index";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import TeamLogo from "../../_partials/TeamLogo";
import { getScaleSize } from "../Lineup/Index";
import { ratioFromFormat } from "../ResultsNew/Index";
import { getImageFilterStyle, getWrapperDimensions } from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import { DEFAULT_ADJUSTMENTS } from "../../../constants/constants";

const getMainBackground = () => {
  return assets.background_1920;
};

const radius = 14;
const goalRadius = 15;
const width = 550;
const height = 847;

function getCssBottom(x, r = radius) {
  return (x / 100) * height - r;
}

// Convert y (0–100, pitch width) into CSS right
function getCssRight(y, r = radius) {
  return (y / 100) * width - r;
}

// For SVG path drawing
function getSvgX(y, r = radius) {
  return width - getCssRight(y, r) - r;
}

function getSvgY(x, r = radius) {
  return height - getCssBottom(x, r) - r;
}

function getSvgPoint(x, y, r = radius) {
  return `${getSvgX(y, r)},${getSvgY(x, r)}`;
}

export default function Index({ animation, data, mode, format, ...props }) {
  const { t } = useTranslation();

  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const selectedLang = data?.lang;

  const prevRatio = props?.prevRatio;

  const onlyData = data?.data; // data?.data;
  const editData = onlyData?.editData;
  const matchInfo = onlyData?.dynamic?.matchInfo;
  const matchDetails = onlyData?.dynamic?.matchDetails;
  const attackingZones = onlyData?.dynamic?.attackingZones;
  const teamSide = onlyData?.dynamic?.teamSide;
  const goalData = onlyData?.dynamic?.goalData || [];
  const kits = onlyData?.dynamic?.kits;
  const isGoalPenalty = goalData?.isPenalty !== undefined ? goalData?.isPenalty : onlyData?.updater?.isPenalty !== undefined ? onlyData?.updater?.isPenalty : false;
  const competitionId = matchInfo?.competition?.id;

  const matchStatus = matchDetails?.matchStatus;
  const scores = matchDetails?.scores;

  const fields = onlyData?.fields;

  const backgroundImage = getMainBackground(format, teamSide);

  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          data: data, // data,
          animation,
          mode,
          id,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });

        animationReturn.timeline.play();
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const goal = goalData?.[goalData?.length - 1];
  const goalPos = goal?.coords?.dest;
  const goalEventId = goal?.eventId;
  const subHeadline = getContentById("subHeadline", fields);
  const selectedMedia1 = getContentById("media1", fields);
  const updater = onlyData?.updater;
  let timeMin = "";
  if (updater) {
    timeMin = updater.timeMin;
  }

  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
  }
  const [effects, setEffects] = useState(defaultEffects)

  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;
    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? defaultEffects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
      }, 500);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: { ...DEFAULT_ADJUSTMENTS },
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        // prevRatioRef.current = 0.56; //default
        setEffects(defaultEffects)
      }
      initializeLayers();
    }
  }, [editData, fields])

  const [ratioSize, setRatioSize] = useState({
    width: 4.075,
    height: 4.075
  });

  useEffect(() => {
    if (prevRatio) {
      setRatioSize(getScaleSize(format, prevRatio));
    } else {
      const editData = data?.data?.editData;
      if (editData) {
        setRatioSize(getScaleSize(format, ratioFromFormat(data.currentFormat)));
      } else {
        setRatioSize(getScaleSize(format, 0));
      }
    }
  }, [format, prevRatio])
  const customBackground = getContentById("background", fields, "self");
  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );
  console.log('layers: ', layers)
  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""} side-${teamSide}`}
    >
      <TemplateBlock>
        <div className={"custom-background-container"}>
          <div
            id={_.get(customBackground, "id", null)}
            style={customBackgroundStyles}
            className={"custom-background"}
          >
            {layers
              .map((layer, index) => {
                const { id, adjustments, imageUrl, dimensions, x, y } = layer;
                const filterStyles = getImageFilterStyle(adjustments);
                const { colorOverlays = [], ...filterStyle } = filterStyles;
                return (
                  <div
                    style={{
                      position: 'absolute',
                      width: `${dimensions.width * ratioSize.width}px`,
                      height: `${dimensions.height * ratioSize.height}px`,
                      left: `${x * ratioSize.width}px`,
                      top: `${y * ratioSize.height}px`,
                      ...filterStyle
                    }}
                    key={id}
                  >
                    <img
                      src={imageUrl}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: "65%", // Adjust as needed
                        background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(30,30,30,1) 100%)",
                        pointerEvents: "none",
                        zIndex: 2,
                      }}
                    />
                    {/* Color overlays */}
                    {colorOverlays.map((overlayStyle, i) => (
                      <div
                        key={i}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          pointerEvents: 'none',
                          ...overlayStyle
                        }}
                      />
                    ))}
                  </div>
                );
              })}
          </div>
        </div>
        {matchStatus && goal && (
          <div className="wc-content wc-content-v2">
            <div className={`${selectedLang === 'ar' ? 'label-container-ar' : 'label-container'}`}>
              <div className="label-match-info-glow">
                {t("Build up play", { keyPrefix: "templates", lng: selectedLang })}
              </div>
              <div className="label-match-info">
                {t("Build up play", { keyPrefix: "templates", lng: selectedLang })}
              </div>
            </div>
            <div className="container">
              <div className="pitch-container">
                <div
                  className="pitch"
                  style={{ backgroundImage: `url(${assets.pitch})` }}
                >

                  {!isGoalPenalty && goalData.map((data) => {
                    return (
                      <div
                        className={`circle eventid-${data?.eventId} ${data?.typeId === 16 ? "shooter" : undefined}`}
                        id={`player-${data?.eventId}-${data?.typeId}`}
                        key={`${data?.eventId}`}
                        style={{
                          bottom: getCssBottom(data?.x),
                          right: getCssRight(data?.y, radius),
                          backgroundColor: (data?.isPlayerOpposite || data?.isOwnGoal) ? 'blue' : '#dd0e26',
                        }}
                      >
                        {data?.player?.shirtNumber}
                      </div>
                    );
                  })}
                  {isGoalPenalty && (
                    <div
                      className={`circle eventid-${goal?.eventId} ${goal?.typeId === 16 ? "shooter" : undefined}`}
                      id={`player-${goal?.eventId}-${goal?.typeId}`}
                      key={`${goal?.eventId}`}
                      style={{
                        bottom: getCssBottom(goal?.x),
                        right: getCssRight(goal?.y, radius),
                      }}
                    >
                      {goal?.player?.shirtNumber}
                    </div>
                  )}
                  <img
                    src={assets.ball}
                    className={`circle goal eventid-${goalEventId}`}
                    id={`goal`}
                    style={{
                      backgroundImage: `url(${assets.ball}`,
                      bottom: height - goalRadius,
                      right: getCssRight(goalPos.y, goalRadius),
                    }}
                  ></img>
                  <svg>
                    {goalData.map((data, index, array) => {
                      const nextPlayer = array[index + 1];

                      //typeId 16 === Goal
                      const destRadius =
                        data.typeId === 16 ? goalRadius : radius;
                      if (data.typeId === 16) {
                        return (
                          <path
                            id={`path-${data.eventId}-${data.typeId}`}
                            className={`path event-${data.typeId}`}
                            key={`${data.x}-${data.y}`}
                            d={`M${getSvgPoint(data.x, data.y)} ${getSvgX(data.coords.dest.y, destRadius)},0z`}
                          />
                        );
                      }

                      const pathStyle = {};

                      // Conditionally add dotted style property
                      if (data.player?.shirtNumber === nextPlayer?.player?.shirtNumber && data?.player?.playerId === nextPlayer?.player?.playerId) {
                        pathStyle.strokeDasharray = '2, 12';
                      }
                      if (!isGoalPenalty) {
                        return (
                          <path
                            id={`path-${data.eventId}-${data.typeId}`}
                            className={`path event-${data.typeId}`}
                            key={`${data.x}-${data.y}`}
                            d={`M${getSvgPoint(data.x, data.y)} ${getSvgPoint(data.coords.dest.x, data.coords.dest.y, destRadius)}z`}
                            style={pathStyle}
                          />
                        );
                      }
                    })}
                  </svg>
                </div>
              </div>
            </div>
            <div className={"bottom-info-container"}>
              <div className="team-logos-container">
                <TeamLogo team={homeTeam} competitionId={competitionId} />
                <TeamLogo team={awayTeam} competitionId={competitionId} />
              </div>
              <div className={`${selectedLang === 'ar' ? "player-name-ar" : "player-name"}`}>
                {t("min", { lng: selectedLang })} {timeMin}'

              </div>
            </div>
            <div className="gradient"></div>
          </div>
        )}
      </TemplateBlock>
    </div>
  );
}
